<template>
  <section class="loading">
    <section class="lds-roller">
      <section></section>
      <section></section>
      <section></section>
      <section></section>
      <section></section>
      <section></section>
      <section></section>
      <section></section>
    </section>
  </section>
</template>
<script lang="ts">
import { Vue } from 'vue-property-decorator';
export default class Loading extends Vue {}
</script>
<style lang="scss" scoped>
.loading {
  height: 100vh;
  text-align: center;
}
.lds-roller {
  display: inline-block;
  height: 80px;
  margin: 160px auto;
  position: relative;
  width: 80px;
}
.lds-roller view {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller view:after {
  content: ' ';
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #777;
  margin: -4px 0 0 -4px;
}
.lds-roller view:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller view:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller view:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller view:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller view:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller view:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller view:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller view:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller view:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller view:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller view:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller view:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller view:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller view:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller view:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller view:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
